import { ChevronLeft } from "lucide-react";

/**
 * Reusable detail-page layout: back link + header + status + sub-text + actions row + tabs.
 * Used by Customer Detail (M2A) and future Project/Payment/Support detail pages.
 *
 * tabs = [{ key, label, count? }]
 */
export default function DetailLayout({
  onBack, backLabel = "← Back",
  title, status, subText,
  actions,             // React node
  tabs = [],
  activeTab,
  onTabChange,
  banner,              // optional notice strip just above the tabs
  children,
  testId = "detail-layout",
}) {
  return (
    <div data-testid={testId}>
      {onBack && (
        <button
          data-testid={`${testId}-back`}
          onClick={onBack}
          className="flex items-center gap-1 text-sm text-brand-muted hover:text-brand-ink mb-4"
        >
          <ChevronLeft className="w-4 h-4" /> {backLabel}
        </button>
      )}
      <div className="flex flex-wrap items-baseline justify-between gap-3 mb-2">
        <h2 className="font-serif text-3xl tracking-tight text-brand-ink" data-testid={`${testId}-title`}>{title}</h2>
        {status}
      </div>
      {subText && (
        <div className="text-sm text-brand-muted mb-4" data-testid={`${testId}-sub`}>{subText}</div>
      )}
      {actions && <div className="mb-6 flex flex-wrap items-center gap-2">{actions}</div>}
      {banner && <div className="mb-4">{banner}</div>}

      {tabs.length > 0 && (
        <div className={`grid gap-px bg-brand-linen border border-brand-linen mb-6`} style={{ gridTemplateColumns: `repeat(${Math.min(tabs.length, 9)}, minmax(0, 1fr))` }} data-testid={`${testId}-tabs`}>
          {tabs.map((t) => (
            <button
              key={t.key}
              data-testid={`${testId}-tab-${t.key}`}
              onClick={() => onTabChange && onTabChange(t.key)}
              className={`p-3 text-sm ${activeTab === t.key ? "bg-brand-navy text-white" : "bg-white hover:bg-brand-linen/30"}`}
            >
              {t.label}{typeof t.count === "number" ? ` (${t.count})` : ""}
            </button>
          ))}
        </div>
      )}

      <div>{children}</div>
    </div>
  );
}
